<template>
  <transition name="modal">
    <!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; top: 100px;">
        <div class="modal-close col-sm-12 text-right">
          <button class="modal-button" @click="closeModal()"><span class="icon-close"></span></button>
        </div>
        <header class="modal-header">
          <h2 class="modal-title ">Interest adjustment - {{noteId}}</h2>
        </header>
        <div class="modal-body mt-lg">
          <slot name="body">
          </slot>
        </div>
        <div class="modal-buttons mt-lg">
            <div class="row">
              <div class="col-md-12 text-right">
              
                <button type="button" class="btn btn-info btn-lg btn-outline" @click="closeModal()">Cancel</button>
                <button type="button" class="btn btn-info btn-lg btn-adjust" @click="submitAction()" :disabled="isSubmitDisabled">Submit adjustments</button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'interestAdjustment',
    props: {
      noteId: {
        type: String,
        required: true,
      },
      isSubmitDisabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      submitAction: {
        type: Function,
        required: true,
      },
      cancelAction: {
        type: Function,
        required: true,
      },
    },
    methods: {
      closeModal() {
        this.cancelAction();
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-adjust {
  background-color: #127285;
}
</style>



// WEBPACK FOOTER //
// InterestAdjustment.vue?86bc441a